import { render, staticRenderFns } from "./app-share-link.vue?vue&type=template&id=d8cec6d6&"
import script from "./app-share-link.vue?vue&type=script&lang=js&"
export * from "./app-share-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports